/*
  Flag keys, owned in the PostHog project (https://eu.posthog.com → Feature
  flags). The live on/off value per environment is set there; the map below only
  governs the fallback used before PostHog resolves.

  Migrated from Split.io. The legacy `hvf_split_react_hook_forms` flag was
  retired — it had no remaining consumer (only its own unit test referenced it),
  so it is intentionally not carried over.
*/
export const POSTHOG_FEATURE_FLAGS = {
  HVF_ADVANCED_EMAIL_VALIDATION: 'hvf_advanced_email_validation',
  HVF_STRICT_ADVANCED_EMAIL_VALIDATION: 'hvf_strict_advanced_email_validation',
} as const;

export type PostHogFeatureFlag = typeof POSTHOG_FEATURE_FLAGS[keyof typeof POSTHOG_FEATURE_FLAGS];

/*
  Value used before PostHog has loaded flags or when PostHog is not configured
  (e.g. local dev without an API key). Flags omitted here default to `false`.
  Both validation flags default `off` (false) — gated email validation stays
  disabled until PostHog resolves the flag to `true`.
*/
export const POSTHOG_FEATURE_FLAG_DEFAULTS: Partial<Record<PostHogFeatureFlag, boolean>> = {
  [POSTHOG_FEATURE_FLAGS.HVF_ADVANCED_EMAIL_VALIDATION]: false,
  [POSTHOG_FEATURE_FLAGS.HVF_STRICT_ADVANCED_EMAIL_VALIDATION]: false,
};
